import React, { Component }        from 'react'
import PropTypes                   from 'prop-types'
import StyleSheet                  from 'styles'

export class Progress extends Component {

  static propTypes = {
    raised: PropTypes.string,
    cap: PropTypes.string,
    currency: PropTypes.string,
  }

  get percent() {
    return (this.props.cap ? this.props.raised / this.props.cap * 100 : 0)
  }

  get percentValueAlignment() {
    if (this.percent < 15)
      return 'left'
    if (this.percent > 85)
      return 'right'
    return ''
  }

  render = () =>
    <div className={this.props.className}>
      <dl className={styles.valueContainer}>
        <dt>Total raised</dt>
        <dd>{(parseFloat(this.props.raised) || 0).toLocaleString()} {this.props.currency}</dd>
      </dl>
      <dl className={styles.valueContainer}>
        <dt>Sale cap</dt>
        <dd>{(parseFloat(this.props.cap) || 0).toLocaleString()} {this.props.currency}</dd>
      </dl>
      <div className={styles.progressContainer}>
        <div className={styles.progress}>
          <span style={{width: `${this.percent}%`}}/>
        </div>
        <span className={styles.pointer} style={{marginLeft: `${this.percent}%`}} />
        <br />
        <span className={`${styles.percentValue} ${this.percentValueAlignment}`} style={{marginLeft: `${this.percent}%`}}>
          {Math.round(this.percent * 10) / 10}% raised
        </span>
      </div>
    </div>
}

export const styles = StyleSheet({
  valueContainer: {
    display: 'inline-block',
    width: '50%',
    '& dt': {
      color: '#6AAEAA',
      fontSize: '16px',
      fontWeight: 'bold',
      paddingBottom: 12,
    },
    '& dd': {
      fontSize: '32px',
      fontWeight: 'bold',
      margin: 0,
    }
  },
  progress: {
    height: 16,
    borderRadius: 6,
    backgroundColor: 'rgba(88, 108, 123, 0.25)',
    display: 'inline-block',
    overflow: 'hidden',
    width: '100%',
    '& span': {
      display: 'block',
      height: '100%',
      borderRadius: 6,
      backgroundColor: '#464646',
    }
  },
  progressContainer: {
    width: '100%',
  },
  pointer: {
    display: 'inline-block',
    width: 0,
    height: 0,
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderBottom: '8px solid #6AAEAA',
    transform: 'translate(-50%, 0)',
    marginTop: 8,
    marginBottom: 3,
  },
  percentValue: {
    whiteSpace: 'nowrap',
    display: 'inline-block',
    transform: 'translate(-50%, 0)',
    fontWeight: 'bold',
    fontSize: '18.5px',
    '&.left': {
      transform: 'translate(-8px, 0)',
    },
    '&.right': {
      transform: 'translate(calc(8px - 100%), 0)',
    }
  }
})